/* eslint-disable no-useless-escape */
import axios from "./axios";

export const addOrg = (token) => {
  window.location.href =
    axios.defaults.baseURL + "/add-account?API-TOKEN=" + token;
};

export const addQboOrg = (token) => {
  window.location.href =
    axios.defaults.baseURL + "/add-qbo-account?API-TOKEN=" + token;
};

export const deleteOrg = (token, id) => {
  return axios.post(
    "/xero-delete",
    {
      asd: "asd",
      id,
    },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const deleteQboOrg = (token, id) => {
  return axios.post(
    "/qbo-delete",
    {
      id,
    },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const qboSync = (token, id) => {
  return axios.post(
    "/qbo-sync",
    { id },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const qboReassign = (token, id, new_user_id) => {
  return axios.post(
    "/qbo-reassign",
    { id, new_user_id },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};
export const bulkConnectOrg = (token, xero_ids) => {
  return axios.post(
    "/connect/xero-bulk",
    {
      xero_ids,
    },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const bulkConnectQboOrg = (token, qbo_ids) => {
  return axios.post(
    "/connect/qbo-bulk",
    {
      qbo_ids,
    },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const bulkSubscribeXeroWithPlans = (token, subscriptions, paymentMethodId = null) => {
  return axios.post(
    "/connect/xero-bulk-plans",
    { subscriptions, payment_method_id: paymentMethodId },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const bulkSubscribeQboWithPlans = (token, subscriptions, paymentMethodId = null) => {
  return axios.post(
    "/connect/qbo-bulk-plans",
    { subscriptions, payment_method_id: paymentMethodId },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const getOrgDataForDashboard = (token, orgId) => {
  return axios.get("/dashboard/org-backup-data/" + orgId, {
    headers: {
      "API-TOKEN": token,
    },
  });
};

export const getOrg = (token, id) => {
  return axios.get("/organization/" + id, {
    headers: {
      "API-TOKEN": token,
    },
  });
};

export const getOrganizations = (token, searchBy) => {
  return axios.get("/xero", {
    headers: {
      "API-TOKEN": token,
    },
    params: {
      q: searchBy,
    },
  });
};

export const getQboOrganizations = (token, searchBy) => {
  return axios.get("/qbo", {
    headers: {
      "API-TOKEN": token,
    },
    params: {
      q: searchBy,
    },
  });
};

export const getFolders = (token, orgId) => {
  return axios.get("/xero/" + orgId, {
    headers: {
      "API-TOKEN": token,
    },
  });
};

export const getFolderModules = (token, orgId, folder_date) => {
  return axios.get("/xero/" + orgId + "/" + folder_date, {
    headers: {
      "API-TOKEN": token,
    },
  });
};

export const getModuleData = (token, orgId, folder_date, module, file_index = null) => {
  const config = {
    headers: {
      "API-TOKEN": token,
    },
  };

  // Add file_index parameter if provided
  if (file_index !== null) {
    config.params = { file_index };
  }

  return axios.get("/xero/" + orgId + "/" + folder_date + "/" + module, config);
};

export const getModuleDataWithSearch = (token, logId, date, moduleName, search, offset = 0) => {
  return axios.get(`${axios.defaults.baseURL}/xero-data-search`, {
    headers: {
      "API-TOKEN": token,
    },
    params: { logId, date, moduleName, search, offset },
  });
};

export const getQboModuleDataWithSearch = (token, logId, date, moduleName, search, offset = 0) => {
  return axios.get(`${axios.defaults.baseURL}/qbo-data-search`, {
    headers: {
      "API-TOKEN": token,
    },
    params: { logId, date, moduleName, search, offset },
  });
};

export const getModuleAttachments = (token, orgId, folder_date, module) => {
  return axios.get(
    "/xero/" + orgId + "/" + folder_date + "/" + module + "/attachments",
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const getQboFolders = (token, orgId) => {
  return axios.get("/qbo/" + orgId, {
    headers: {
      "API-TOKEN": token,
    },
  });
};

export const getQboFolderModules = (token, orgId, folder_date) => {
  return axios.get("/qbo/" + orgId + "/" + folder_date, {
    headers: {
      "API-TOKEN": token,
    },
  });
};

export const getQboModuleData = (token, orgId, folder_date, module, file_index = null) => {
  const config = {
    headers: {
      "API-TOKEN": token,
    },
  };

  // Add file_index parameter if provided (same paging behavior as Xero).
  if (file_index !== null) {
    config.params = { file_index };
  }

  return axios.get("/qbo/" + orgId + "/" + folder_date + "/" + module, config);
};

export const getQboModuleAttachments = (token, orgId, folder_date, module) => {
  return axios.get(
    "/qbo/" + orgId + "/" + folder_date + "/" + module + "/attachments",
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const subUpdate = (token, orgId) => {
  return axios.post(
    "/xero/update-subscription",
    {
      id: orgId,
    },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const connectXero = (token, orgId) => {
  return axios.post(
    "/connect/xero",
    {
      id: orgId,
    },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const disconnectXero = (token, orgId, couponCode = null) => {
  const payload = { id: orgId };
  if (couponCode) {
    payload.coupon_code = String(couponCode).trim();
  }
  return axios.post(
    "/xero-disconnect",
    payload,
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const subQboUpdate = (token, orgId) => {
  return axios.post(
    "/qbo/update-subscription",
    {
      id: orgId,
    },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const connectQbo = (token, orgId) => {
  return axios.post(
    "/connect/qbo",
    {
      id: orgId,
    },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const disconnectQbo = (token, orgId, couponCode = null) => {
  const payload = { id: orgId };
  if (couponCode) {
    payload.coupon_code = String(couponCode).trim();
  }
  return axios.post(
    "/qbo-disconnect",
    payload,
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const revokeXeroConnection = (token, orgId) => {
  return axios.post(
    "/xero-revoke-connection",
    { id: orgId },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const revokeQboConnection = (token, orgId) => {
  return axios.post(
    "/qbo-revoke-connection",
    { id: orgId },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

// Syncs local DB state after Intuit's App Store / Apps tab "Disconnect" flow
// has already revoked the company's OAuth tokens on Intuit's side.
export const markQboDisconnected = (token, realmId) => {
  return axios.post(
    "/qbo-mark-disconnected",
    { realmId },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const xeroClearData = (token, id) => {
  return axios.post(
    "xero-clear",
    {
      id,
    },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const restoreOrg = (token, source, dest, folder_date) => {
  return axios.post(
    "/xero-resync",
    {
      source,
      dest,
      folder_date,
    },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const qboClearData = (token, id) => {
  return axios.post(
    "/qbo-clear",
    {
      id,
    },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const restoreQboOrg = (token, source, dest, folder_date) => {
  return axios.post(
    "/qbo-resync",
    {
      source,
      dest,
      folder_date,
    },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const getRestoreEstimate = (token, org_id, date) => {
  return axios.post(
    "/organization/restore-estimate",
    { org_id, date },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const moduleFileDownload = (token, link) => {
  return axios.post(
    "/" + link,
    {},
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const downloadFileFromResponse = (response) => {
  // Extract the Content-Disposition header
  const contentDisposition = response.headers["content-disposition"];

  // Initialize a default filename
  let fileName = "downloaded_file";

  // Extract the filename if Content-Disposition contains it
  if (contentDisposition && contentDisposition.indexOf("filename=") !== -1) {
    const matches = contentDisposition.match(/filename="?(.+)"?/);
    console.log("matches", matches);
    if (matches && matches[1]) {
      fileName = matches[1];
    }
  }
  fileName = fileName.replace(/^\"+|\"+$/g, "");

  // Create a Blob from the response
  const blob = new Blob([response.data], {
    type: response.headers["content-type"],
  });

  // Create a temporary URL for the Blob
  const url = window.URL.createObjectURL(blob);

  // Create an anchor element to trigger the download
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = fileName; // Use the extracted filename

  // Append the anchor to the body
  document.body.appendChild(a);
  a.click();

  // Cleanup
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const downloadModuleBackup = (token, id, date, moduleName) => {
  return axios.post(
    "/download-backup/" + id + "/" + date + "/" + moduleName,
    {},
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const downloadTotalBackup = (token, id, date) => {
  return axios.post(
    "/download-backup/" + id + "/" + date,
    {},
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const downloadTotalFiles = (token, id) => {
  return axios.post(
    "/download-backup-files/" + id,
    {},
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const downloadSingleFile = (token, url) => {
	return axios.get(
		url,
	)
}

export const updateDemoTour = (token) => {
  return axios.post(
    "/user/demoTourFinished",
    {},
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const cancelSubscription = (token, orgId) => {
  return axios.post(
    `/subscription-cancel/${orgId}`,
    {},
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const cancelQboSubscription = (token, orgId) => {
  return axios.post(
    `/qbo-subscription-cancel/${orgId}`,
    {},
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};
export const getAttachments = (token, orgId) => {
  return axios.post(
    `/get-attachments/${orgId}`,
    {},
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const uploadAttachment = (token, orgId, formData) => {

  return axios.post(
    `/upload-attachment/${orgId}`,
    formData,
    {
      headers: {
        "API-TOKEN": token,
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
export const openAttachment = (token, orgId, formData) => {

  return axios.post(
    `/open-file/${orgId}`,
    formData,
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};
export const deleteAttachment = (token, orgId, formData) => {

  return axios.post(
    `/delete-file/${orgId}`,
    formData,
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const subscribeWithModulePlan = (token, org_id, plans) => {
	return axios.post(
		'/xero/subscription/plans',
		{
			...plans,
			org_id,
		},
		{
			headers: {
				"API-TOKEN": token,
			}
		}
	)
}

export const initiateQBDToXeroPayment = (token, numberOfMigrations, orgSetupOption) => {
	return axios.post(
		'/qbd-to-xero/payment',
		{
			numberOfMigrations,
			orgSetupOption,
		},
		{
			headers: {
				"API-TOKEN": token,
			}
		}
	)
}

export const sendXeroReauthEmail = (token, data) => {
	const endpoint = (data?.provider === 'qbo' || data?.qbo_id)
		? '/qbo/send-reauth-email'
		: '/xero/send-reauth-email';
	return axios.post(endpoint, data, {
		headers: {
			"API-TOKEN": token,
		},
	});
};

export const sendSubscriptionEmail = (token, data) => {
	const endpoint = (data?.provider === 'qbo' || data?.qbo_id)
		? '/qbo/send-subscription-email'
		: '/xero/send-subscription-email';
	return axios.post(endpoint, data, {
		headers: {
			"API-TOKEN": token,
		},
	});
};

export const sendXeroSubscriptionEmail = sendSubscriptionEmail;

export const validateCoupon = (token, couponCode) => {
	return axios.post(
		'/payment/validate-coupon',
		{ coupon_code: couponCode },
		{
			headers: {
				"API-TOKEN": token,
			},
		}
	);
};

export const adminManualSubscription = (token, data) => {
	return axios.post('/user/admin-manual-subscription', data, {
		headers: {
			"API-TOKEN": token,
		},
	});
};

export const getAdminManualSubscriptionsList = (token, orgId, provider = 'xero') => {
	return axios.get(`/user/admin-manual-subscriptions-list?org_id=${orgId}&provider=${provider}`, {
		headers: {
			"API-TOKEN": token,
		},
	});
};

export const getRestoreComparisonReport = (token, type, restoreQueueId) => {
	return axios.get(`/user/getRestoreComparisonReport/${type}/${restoreQueueId}`, {
		headers: {
			"API-TOKEN": token,
		},
	});
};

export const getOrgBulkApiSettings = (token, orgId, provider = 'xero') => {
	return axios.get(`/user/admin-org-bulk-api-settings?org_id=${orgId}&provider=${provider}`, {
		headers: {
			"API-TOKEN": token,
		},
	});
};

export const updateOrgBulkApiSettings = (token, data) => {
	return axios.post('/user/admin-org-bulk-api-settings', data, {
		headers: {
			"API-TOKEN": token,
		},
	});
};

export const getBackupRetention = (token, orgId, provider = 'xero', extraParams = {}) => {
	const params = new URLSearchParams({ org_id: orgId, provider });
	if (extraParams && extraParams.files != null) {
		params.set('files', extraParams.files);
	}
	if (extraParams && extraParams.history_and_notes != null) {
		params.set('history_and_notes', extraParams.history_and_notes);
	}
	return axios.get(`/user/backup-retention?${params.toString()}`, {
		headers: {
			"API-TOKEN": token,
		},
	});
};

export const updateBackupRetention = (token, data) => {
	return axios.post('/user/update-backup-retention', data, {
		headers: {
			"API-TOKEN": token,
		},
	});
};

export const getSubscriptionAddons = (token, orgId, provider = 'xero') => {
	const params = new URLSearchParams({ org_id: orgId, provider });
	return axios.get(`/user/subscription-addons?${params.toString()}`, {
		headers: {
			"API-TOKEN": token,
		},
	});
};

export const updateSubscriptionAddons = (token, data) => {
	return axios.post('/user/update-subscription-addons', data, {
		headers: {
			"API-TOKEN": token,
		},
	});
};


